import React, { useEffect, useState } from 'react';
import api from 'services/api';
import Table from 'components/Table';
import BrazilMoney from 'utils/BrazilMoney';
import { useSelector } from 'react-redux';

function Lots() {
  const [lots, setLots] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);
  const columns = [
    {
      title: 'Nome',
      field: 'name',
      type: 'string',
      hideFilterIcon: true,
    },
    {
      title: 'Espécie',
      field: 'specie.name',
      type: 'string',
      hideFilterIcon: true,
    },
    {
      title: 'Idade dos Animais',
      field: 'old',
      editable: 'never',
      hideFilterIcon: true,
    },
    {
      title: 'Quantidade de Animais',
      field: 'size',
      hideFilterIcon: true,
      editable: 'never',
      render: (rowData) => (
        <span>{new Intl.NumberFormat('pt-BR').format(rowData.size)}</span>
      ),
    },
    {
      title: 'Quantidade de Animais Restantes',
      field: 'size_remain',
      hideFilterIcon: true,
      editable: 'never',
      render: (rowData) => (
        <span>{new Intl.NumberFormat('pt-BR').format(rowData.size_remain)}</span>
      ),
    },
    {
      title: 'Preço da Remessa',
      field: 'price',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => (
        <span><BrazilMoney value={rowData.price} /></span>
      ),
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/lots');
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setLots(response.data);
          setOpenProgress(true);
        }
      } catch (err) {
      }
    } loadData();
  }, [nameProperty]);

  function setData(newData) {
    const tempData = [];
    lots.map((lot) => (
      lot.id === newData.id ? tempData.push(newData) : tempData.push(lots)
    ));
    setLots(tempData);
  }

  return (
    <Table
      isVisible
      title="Remessa"
      route="/lots/"
      routeAdd="/lot/"
      routeForConsignmentPurchase="/purchase/"
      productType="remittance"
      columns={columns}
      data={lots}
      setData={setData}
      dataLoaded={openProgress}
    />
  );
}

export default Lots;
